import Vue from 'vue';
import VeeValidate, {Validator} from 'vee-validate';

Validator.localize({
  en: {
    custom: {
      invitationKey: {
        required: 'The invitation key or UAS serial number is required',
      },
      firstName: {
        required: 'Please enter your first name',
      },
      lastName: {
        required: 'Please enter your last name',
      },
      email: {
        required: 'Please enter a valid email address',
      },
    },
  },
});

Vue.use(VeeValidate, {
  fieldsBagName: 'fieldsBag',
});



// WEBPACK FOOTER //
// ./src/plugins/VeeValidate.ts